<template>
    <div id="RequestList">
        <a-spin :spinning="isLoading">
            <div class="searchArea">
                <a-row>
                    <a-col class="requestTitle">
                        My requests：
                    </a-col>
                </a-row>
                <a-row class="mar-T-30 p-t-10">
                    <a-col :span="3" class="subtitle">
                        Delivery Number
                    </a-col>
                    <a-col :span="6">
                        <a-input v-model="deliveryNum" placeholder="Please Input Delivery Number"></a-input>
                    </a-col>

                    <a-col :span="3" class="subtitle">
                        Status
                    </a-col>
                    <a-col :span="6">
                        <a-select allowClear style="width: 100%" v-model="statusSelect"
                                  placeholder="Please Select Status">
                            <a-select-option v-for="(item, index) in statusArray" :key="index" :value="item.value">
                                {{item.name}}
                            </a-select-option>
                        </a-select>
                    </a-col>

                </a-row>
                <a-row class="p-t-10">
                    <a-col :span="3" class="subtitle">
                        Case Number
                    </a-col>
                    <a-col :span="6">
                        <a-input v-model="caseNum" placeholder="Please Input Case Number"></a-input>
                    </a-col>

                    <a-col :span="3" class="subtitle">
                        Update Time
                    </a-col>
                    <a-col :span="6">
                        <a-range-picker style="width: 100%" @change="onChange"/>
                    </a-col>
                </a-row>
                <a-row class="p-t-10">
                    <a-col :span="2" :offset="20">
                        <a-button type="primary" style="min-width:100px;font-size: 14px;width: 100%" @click="requestPageListArray">
                            Search
                        </a-button>
                    </a-col>
                </a-row>
            </div>
            <a-row v-if="pageType === '1'" class="mar-T-30" type="flex" justify="start">
                <a-col >
                    <a-select style="min-width:160px" placeholder="Please Select BG" v-model="selectGCDOrPCG"
                              @change="handleChange" allowClear>
                        <a-select-option v-for="(item, index) in GCDOrPCGList" :key="index" :value="item.value">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col >
                    <a-select style="min-width: 200px;margin-left: 10px;" placeholder="Please Select Request" v-model="selectGCDOrPCGItem"
                              allowClear>
                        <a-select-option v-for="(item, index) in GCDOrPCGItems" :key="index" :value="item.code">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-col>
                <a-col style="margin-left: 10px;">
                    <a-button class="addButton" @click="addNewCase">Raise New Request</a-button>
                </a-col>
            </a-row>

            <a-row v-if="pageType === '1'" class="mar-T-30">
                <div class="selectNumber"></div>
            </a-row>

            <a-row class="mar-T-30">
                <a-col :span="24">
                    <a-table :loading="loading"
                             :columns="columns"
                             :scroll="{x: true}"
                             :data-source="response" :rowKey="rowKey"
                             @change="pageSizeOnChange"
                             :customRow="customRowFun">
                        <template slot="updateTime" slot-scope="updateTime">
                            {{timeToString(updateTime)}}
                        </template>
                        <template slot="edit"
                                  slot-scope="text">
                            <a-button v-if="(text.edit === 1 && pageType === '1')"
                                      class="normalButton"
                                      @click="editeButtonClick(text)">Edit
                            </a-button>
                            <a-button style="margin-left: 5%"
                                      v-if="(text.edit === 1 && text.status === 'Draft' && pageType === '1')"
                                      class="normalButton"
                                      @click="deleteOrder(text)">Delete
                            </a-button>
                            <a-button v-if="(text.edit === 0 && pageType === '1')"
                                      class="normalButton"
                                      @click="viewButtonClick(text)">View
                            </a-button>
                            <a-button v-if="(text.edit === 0 && pageType === '2')"
                                      class="normalButton"
                                      @click="enterButtonClick(text)">View
                            </a-button>
                            <a-button v-if="(text.edit === 1 && pageType === '2')"
                                      class="normalButton"
                                      @click="enterButtonClick(text)">Enter
                            </a-button>
                        </template>
                    </a-table>
                </a-col>
            </a-row>
        </a-spin>
    </div>
</template>

<script>
    import {tableCol, RequestConfig} from './ReauestListConfig'
    import {
        getListArray,
        getProcessStatus,
        getBgAndSelectionArray,
        withdrawOrder
    } from './RequestListApiMethod'
    import moment from 'moment'

    export default {
        name: 'RequestList',
        data() {
            return {
                columns: [],
                response: [],
                pageType: '', // 1 是Carrier 2 是CF
                statusSelect: [],
                statusArray: [],
                pageSize: 10,
                pageNo: 1,
                total: 0,
                loading: false,
                isLoading: false,
                rowKey: (record, index) => index,
                deliveryNum: '',
                caseNum: '',
                pagination: {
                    defaultCurrent: this.pageNo,
                    pageSize: this.pageSize,
                    pageSizeOptions: ['10', '20', '30', '40'],
                    showSizeChanger: true,
                    total: this.total
                },
                updateTimeRange: {
                    startDate: null,
                    endDate: null
                },
                selectGCDOrPCG: [],
                selectGCDOrPCGItem: [],
                totalBGArray: [],
                GCDOrPCGList: [{
                    value: 'DCG',
                    name: 'DCG'
                }, {
                    value: 'IDG',
                    name: 'IDG'
                }],
                GCDOrPCGItems: []
            }
        },
        destroyed() {
        },
        created() {
            this.columns = tableCol
            if (this.$route.query.pageType) {
                this.pageType = this.$route.query.pageType
            }
            this.requestPageListArray()
            this.requestProcessStatus()
            this.requestBGData()
        },
        methods: {
            timeToString(dateValue1) {
                if (dateValue1) return this.$moment(dateValue1).utc(false).utcOffset(1).format('YYYY-MM-DD HH:mm:ss')
                // if (dateValue1) return this.$moment(dateValue1).utc(false).utcOffset(1).format('YYYY-MM-DD HH:mm:ss')
                return ''
            },
            customRowFun(record, index) { // 设置行属性
                return {
                    on: {
                        click: (record) => {
                            // console.log('click record : ', record)
                        },
                        dblclick: (record) => {
                        }
                    }
                }
            },
            onChange(date, dateString) {
                if (date && date.length > 1) {

                    var a = moment(date[0]).utc(false).format('YYYY-MM-DD')
                    var b = moment(date[1]).day(1).utc(false).format('YYYY-MM-DD')
                    a = a + ' ' + '00:00:00'
                    // b = b + ' ' + '23:59:59'
                    b = b + ' ' + '00:00:00'
                    const startDate = moment(a).utc(false)
                    const endDate = moment(b).utc(false)

                    // console.log(111111)
                    // // moment.tz.setDefault("Asia/Tokyo");
                    //
                    // console.log(a)
                    // console.log(b)
                    // console.log(moment(a).parseZone('Ljubljana'))
                    // console.log(endDate)
                    // console.log(222222)
                    // console.log(moment(date[0]).utc(true))
                    // console.log(moment(date[1]).utc(true))
                    // console.log(33333333)

                    // const startDate = moment(date[0]).utc(true)
                    // const endDate = moment(date[1]).utc(true)
                    this.updateTimeRange.startDate = startDate
                    this.updateTimeRange.endDate = endDate
                } else {
                    this.updateTimeRange = {
                        startDate: null,
                        endDate: null
                    }
                }
            },
            requestBGData() {
                getBgAndSelectionArray().then(res => {
                    this.totalBGArray = []
                    for (var i = 0; i < res.length; i++) {
                        const item = res[i]
                        if (this.pageType === '1') {
                            if (item.lvoCaseType === 'CARRIER') {
                                this.totalBGArray.push(item)
                            }
                        } else {
                            if (item.lvoCaseType === 'CF') {
                                this.totalBGArray.push(item)
                            }
                        }
                    }
                }).catch(error => {
                    this.loading = false
                })
            },
            requestPageListArray() {
                var caseType = ''
                if (this.pageType === '1') {
                    caseType = 'CARRIER'
                } else {
                    caseType = 'CF'
                }
                const param = {
                    caseType: caseType,
                    caseNum: this.caseNum ? this.caseNum : null,
                    deliveryNum: this.deliveryNum ? this.deliveryNum : null,
                    caseStatus: (this.statusSelect && this.statusSelect.length > 0) ? this.statusSelect : null,
                    updateTimeRange: this.updateTimeRange,
                    pageNo: this.pageNo,
                    pageSize: this.pageSize,
                    email: this.$store.getters.getUserEmail
                }

                this.loading = true

                getListArray(param).then(res => {
                    this.loading = false
                    this.response = res
                }).catch(() => {
                    this.loading = false
                })
            },
            requestProcessStatus() {
                this.statusArray = []
                let caseType = '';
                this.statusArray.push({
                    name: 'All',
                    value: ''
                })
                if (this.pageType === '1') {
                    caseType = 'CARRIER'
                } else {
                    caseType = 'CF'
                }
                getProcessStatus(caseType).then(res => {
                    for (const item of res) {
                        this.statusArray.push({
                            name: item,
                            value: item
                        })
                    }
                })
            },
            handleChange(e) {
                if (e !== this.selectGCDOrPCG) {
                    this.GCDOrPCGItems = []
                    this.selectGCDOrPCGItem = []
                }

                if (e) {
                    this.GCDOrPCGItems = []
                    this.totalBGArray.forEach(res => {
                        if (res.buType === 'BOTH' || res.buType === e) {
                            this.GCDOrPCGItems.push({
                                name: res.lvoName,
                                code: res.lvoCaseTypeId
                            })
                        }
                    })
                    // this.GCDOrPCGItems = RequestConfig[e]
                } else {
                    this.GCDOrPCGItems = []
                    this.selectGCDOrPCGItem = []
                }
            },
            addNewCase() {
                if (this.selectGCDOrPCG.length > 0 && this.selectGCDOrPCGItem.length > 0) {
                    this.$router.push({
                        path: '/request-list/raise-new-case',
                        query: {
                            buyType: this.selectGCDOrPCG,
                            caseId: this.selectGCDOrPCGItem,
                            pageType: '1'
                        }
                    })
                } else {
                    this.$message.warn('Please Select BG And BG Item')
                }
            },
            getPageCodeBy(bgString, bgItemCode) {
                const allConfig = RequestConfig[bgString] ? RequestConfig[bgString] : []
                var selectionName = ''
                var selectionCode = ''
                this.totalBGArray.forEach(res => {
                    if (res.lvoCaseTypeId === bgItemCode) {
                        selectionName = res.lvoName
                    }
                })
                for (var i = 0; i < allConfig.length; i++) {
                    const item = allConfig[i]
                    if (item.name.toLowerCase() === selectionName.toLowerCase()) {
                        selectionCode = item.code
                    }
                }
                return selectionCode
            },
            deleteOrder(e) {
                const a = e.uuid
                const self = this
                this.$confirm({
                    title: 'Warning',
                    content: 'Please confirm your deletion action!',
                    cancelText: 'Yes',
                    icon: 'exclamation-circle',
                    onCancel() {
                        self.destroyAll()
                        self.submitDelete(a)
                    },
                    okText: 'No',
                    okButtonProps: {props: {type: ''}},
                    cancelButtonProps: {props: {type: 'primary'}},
                    onOk() {
                        self.destroyAll()
                    }
                })
            },
            destroyAll() {
                this.$destroyAll()
            },

            submitDelete(uid) {
                withdrawOrder(uid).then(res => {
                    if (res.success) {
                        this.$message.success('Success')
                        this.requestPageListArray()
                    } else {
                        var msg = res.errors[0] ? res.errors[0] : 'Error'
                        this.$message.error(msg)
                    }
                })
            },
            getSelectBGItemCode(bgString, bgItemCode) {
                const allConfig = RequestConfig[bgString] ? RequestConfig[bgString] : []
                var selectionName = ''
                var selectionCode = ''
                this.GCDOrPCGItems.forEach(res => {
                    if (res.code === bgItemCode) {
                        selectionName = res.name
                    }
                })
                for (var i = 0; i < allConfig.length; i++) {
                    const item = allConfig[i]
                    if (item.name.toLowerCase() === selectionName.toLowerCase()) {
                        selectionCode = item.code
                    }
                }
                return selectionCode
            },
            editeButtonClick(e) {
                const a = e.uuid
                const aaa = this.getPageCodeBy(e.buType, e.uuid)

                if (a) {
                    var param = {
                        pageType: '3',
                        uuid: a
                    }
                    this.pushToDetailView(param)
                }
            },

            viewButtonClick(e) {
                const a = e.uuid
                const aaa = this.getPageCodeBy(e.buType, e.uuid)

                if (a) {
                    var param = {
                        pageType: '3',
                        uuid: a
                    }
                    this.pushToDetailView(param)
                }
            },

            pushToDetailView(param) {
                this.$router.push({
                    path: '/request-list/case-detail',
                    query: param
                })
            },

            enterButtonClick(e) {
                const a = e.uuid

                this.$router.push({
                    path: '/task-list/task-detail',
                    query: {
                        uid: a
                    }
                })
            },
            pageSizeOnChange(pagination, filters, sorter) {
                // console.log('pageSizeOnChange : ', pagination)
                // console.log('pageSizeOnChange : ', filters)
                // console.log('pageSizeOnChange : ', sorter)
            }
        }
    }
</script>

<style lang="scss" scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #RequestList {
        text-align: left;

        .requestTitle {
            background-color: #e6f7ff;
            border-radius: 5px;
            padding: 10px;
            font-size: 14px;
            color: rgb(49, 112, 143);
            line-height: 20px;
            font-weight: 600;
        }

        .mar-T-30 {
            margin-top: 30px;
        }

        .mar-L-10 {
            margin-top: 10px;
        }

        .p-t-10 {
            padding-top: 10px;
        }

        .subtitle {
            font-size: 14px;
            font-weight: 800;
            text-align: right;
            padding-right: 10px;
            color: #027DB4;

        }

        .searchArea {
            width: 100%;
            height: auto;
            padding-bottom: 20px;
            border-bottom: 1px solid #91d5ff;
        }

        .selectNumber {
            width: 100%;
            height: 0px;
            border-radius: 5px;
            border-bottom: 1px solid #91d5ff;
        }

        .normalButton {
            width: 45%;
            padding: 0;
            padding-left: 5px;
            padding-right: 5px;
            text-align: center;
            color: #40a9ff;
            border: 1px solid #40a9ff;
        }

        .addButton {
            color: #40a9ff;
            border: 1px solid #40a9ff;
        }
    }
</style>
